<template>
<div id="screenContainer" @click="navigateHome">
    <img class="img-error" :src="imageSrc" v-if="errorType !== 'printerError'">
    <!--<span v-if="errorType === 'printerError'">{{ pagerCode }}</span>-->
    <div class="error-message-printer" v-if="errorType === 'printerError'">
        <img :src="imageSrc"/>
        <div class="error-message-printer-title">{{ getString('pedido_concluido_erro_impressora_1') }}</div>
        <div class="error-message-printer-subtitle subtile-2">{{ getString('pedido_concluido_erro_impressora_2') }}</div>
        <div class="error-message-printer-subtitle subtile-3">{{ getString('pedido_concluido_erro_impressora_3') }}</div>
        <div class="error-message-printer-subtitle subtile-4">{{ getString('pedido_concluido_erro_impressora_4') }}</div>
        <div class="error-message-printer-subtitle subtile-5">{{ getString('pedido_concluido_erro_impressora_5') }}</div>
        <div class="error-message-printer-subtitle subtile-6">{{ getString('pedido_concluido_erro_impressora_6') + pagerCode}}</div>
        <div class="error-message-printer-subtitle subtile-10" v-if="saleInfo && saleInfo.nfceCode">{{ getString('pedido_concluido_erro_impressora_10') + (saleInfo.nfceCode) }}</div>
        <div class="error-message-printer-subtitle subtile-10" v-if="saleInfo && saleInfo.saleDate">{{ getString('data_pedido') + ' ' + (saleInfo.saleDate.replace(/-/g, '/')) }}</div>
        <div class="error-message-printer-subtitle subtile-7">{{ getString('pedido_concluido_erro_impressora_7') + (saleInfo.saleSeq || saleInfo.saleCode) }}</div>
        <div class="error-message-printer-subtitle subtile-8">{{ getString('pedido_concluido_erro_impressora_8') }}</div>
        <div class="error-message-printer-subtitle subtile-9">{{ getString('pedido_concluido_erro_impressora_9') }}</div>
    </div>
</div>
</template>

<script>

import CartController from '@/assets/controllers/CartController'
import SaleController from '@/assets/controllers/SaleController'
import LocaleController from '@/assets/controllers/LocaleController'
import Util from '@/assets/libs/util'
import ClarityController from '@/assets/controllers/ClarityController'

export default {
    name: 'ErrorScreen',
    data () {
        return {
            pagerCode: CartController.getPagerCode(),
            saleInfo: SaleController.getSaleInfo(),
            errorType: null,
            imageSrc: null,
            errors: {
                'printerError': require('../../static/icons/printer.png'),
                'saveSaleError': Util.getConfigImage('erroSalvarVenda') ? Util.getConfigImage('erroSalvarVenda') : require('../../static/icons/sale_error.png'),
                'tefError': Util.getConfigImage('erroTEF') ? Util.getConfigImage('erroTEF') : require('../../static/icons/tef_error.png'),
                'pinPadError': Util.getConfigImage('erroPinpad') ? Util.getConfigImage('erroPinpad') : require('../../static/icons/pinpad_error.png')
            }
        }
    },
    mounted () {
        this.errorType = this.$route.params.errorType
        if (this.errorType === 'printerError') {
            ClarityController.event('erro_impressora')
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        navigateHome: function () {
            // Limpa o carrinho
            CartController.resetCart()
            // Retorna para a tela inicial
            this.$router.push('/')
        },
        getErrorMessage: function () {
            if (this.errorType === 'printerError') {
                ClarityController.event('erro_impressora')
                return this.getString('pedido_concluido_erro_impressora_1')
            }
        }
    },
    watch: {
        'errorType': function (errorType) {
            this.imageSrc = this.errors[errorType]
            this.$forceUpdate()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    #screenContainer {
        width: 100vw;
        height: 100vh;
        background-color: #ffba5f;
        .img-error {
            width: 100vw;
            object-fit: cover;
        }
        span {
            position: fixed;
            top: 1340px;
            left: 600px;
            font-size: 100px;
        }
        .error-message-printer {
            text-transform: uppercase;
            text-align: center;
            padding: 50px 30px;
            img {
                width: 300px;
                height: 300px;
                object-fit: cover;
                margin: 100px auto;
            }
            .error-message-printer-title {
                font-size: 3em;
                font-weight: 500;
            }
            .error-message-printer-subtitle {
                font-size: 2.5em;
                padding: 50px 0;
            }
            .error-message-printer-subtitle.subtile-3 {
                font-size: 2.4em;
                text-align: left;
                padding: 20px 0 0 0;
            }
            .error-message-printer-subtitle.subtile-4, .error-message-printer-subtitle.subtile-5 {
                font-size: 2.4em;
                text-align: left;
                padding: 30px 0 0 30px;
                font-weight: 400;
            }
            .error-message-printer-subtitle.subtile-6, .error-message-printer-subtitle.subtile-7 {
                font-weight: 600;
                padding: 20px 0 15px 0;
            }
            .error-message-printer-subtitle.subtile-6 {
                padding-top: 60px;
            }
            .error-message-printer-subtitle.subtile-7{
                padding: 15px 0 60px 0;
            }
            .error-message-printer-subtitle.subtile-10{
                font-weight: 600;
                padding: 15px 0 15px 0;
            }
            .error-message-printer-subtitle.subtile-8 {
                padding: 20px 0 0 0;
            }
        }
    }

    @media (max-width: 698px) { // Gertec SK210
        #screenContainer {
            .img-error {
                height: 100vh;
                width: 100vw;
                object-fit: cover;
            }

            span {
                position: fixed;
                top: 500px;
                left: 250px;
                font-size: 50px;
            }

            .error-message-printer {
                padding: 20px 15px;
                img {
                    width: 100px;
                    height: 100px;
                    margin: 15px auto;
                }
                .error-message-printer-title {
                    font-size: 1em;
                    font-weight: 500;
                }
                .error-message-printer-subtitle {
                    font-size: 0.9em;
                    padding: 15px 0;
                }
                .error-message-printer-subtitle.subtile-3 {
                    font-size: 0.9em;
                    text-align: left;
                    padding: 10px 0 0 0;
                }
                .error-message-printer-subtitle.subtile-4, .error-message-printer-subtitle.subtile-5 {
                    font-size: 0.9em;
                    text-align: left;
                    padding: 10px 0 0 10px;
                    font-weight: 400;
                }
                .error-message-printer-subtitle.subtile-6, .error-message-printer-subtitle.subtile-7 {
                    font-weight: 600;
                    padding: 10px 0 5px 0;
                }
                .error-message-printer-subtitle.subtile-6 {
                    padding-top: 10px;
                }
                .error-message-printer-subtitle.subtile-7{
                    padding: 8px 0 10px 0;
                }
                .error-message-printer-subtitle.subtile-10{
                    font-weight: 600;
                    padding: 5px 0 5px 0;
                }
                .error-message-printer-subtitle.subtile-6, .error-message-printer-subtitle.subtile-7, .error-message-printer-subtitle.subtile-10 {
                    font-size: 0.9em;
                }
            }
        }

    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        #screenContainer {
            .img-error {
                width: 100vw;
                object-fit: cover;
            }

            span {
                position: fixed;
                top: 985px;
                left: 420px;
                font-size: 80px;
            }

            .error-message-printer {
            text-transform: uppercase;
            text-align: center;
            padding: 50px 30px;
            img {
                width: 250px;
                height: 250px;
                object-fit: cover;
                margin: 30px auto;
            }
            .error-message-printer-title {
                font-size: 2.5em;
                font-weight: 400;
            }
            .error-message-printer-subtitle {
                font-size: 1.8em;
                padding: 30px 0;
            }
            .error-message-printer-subtitle.subtile-3 {
                font-size: 1.8em;
                text-align: left;
                padding: 20px 0 0 0;
            }
            .error-message-printer-subtitle.subtile-4, .error-message-printer-subtitle.subtile-5 {
                font-size: 1.8em;
                text-align: left;
                padding: 20px 0 0 30px;
                font-weight: 400;
            }
            .error-message-printer-subtitle.subtile-6, .error-message-printer-subtitle.subtile-7 {
                font-weight: 600;
                padding: 15px 0 15px 0;
            }
            .error-message-printer-subtitle.subtile-6 {
                padding-top: 50px;
            }
            .error-message-printer-subtitle.subtile-7{
                padding: 15px 0 50px 0;
            }
            .error-message-printer-subtitle.subtile-10{
                font-weight: 600;
                padding: 15px 0 15px 0;
            }
        }
        }
    }

    @media (orientation: landscape) {
        #screenContainer {
            .img-error {
                width: 100vw;
                object-fit: cover;
            }
            .error-message-printer {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding: 20px 40px;
                height: 100vh;
                box-sizing: border-box;

                img {
                    width: 180px;
                    height: 180px;
                    object-fit: cover;
                    margin: 20px auto;
                    flex-shrink: 0;
                }

                .error-message-printer-title {
                    font-size: 1.6em;
                    font-weight: 500;
                    margin-bottom: 15px;
                }

                .error-message-printer-subtitle {
                    font-size: 1.4em;
                    padding: 8px 0;
                    line-height: 1.1;
                }

                .error-message-printer-subtitle.subtile-2 {
                    margin-bottom: 20px;
                }

                .error-message-printer-subtitle.subtile-3 {
                    font-size: 1.4em;
                    text-align: left;
                    padding: 10px 0 5px 0;
                    margin-bottom: 5px;
                }

                .error-message-printer-subtitle.subtile-4,
                .error-message-printer-subtitle.subtile-5 {
                    font-size: 1.4em;
                    text-align: left;
                    padding: 8px 0 0 20px;
                    font-weight: 400;
                }

                .error-message-printer-subtitle.subtile-6 {
                    font-weight: 600;
                    padding: 15px 0 8px 0;
                    margin-top: 20px;
                }

                .error-message-printer-subtitle.subtile-7 {
                    font-weight: 600;
                    padding: 8px 0 15px 0;
                }

                .error-message-printer-subtitle.subtile-10 {
                    font-weight: 600;
                    padding: 8px 0;
                }

                .error-message-printer-subtitle.subtile-8 {
                    padding: 10px 0 5px 0;
                }

                .error-message-printer-subtitle.subtile-9 {
                    padding: 5px 0 0 0;
                }
            }

            span {
                position: fixed;
                top: 600px;
                left: 450px;
                font-size: 70px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/ErrorScreen.vue